import React from 'react';
import { useTranslation } from 'react-i18next';
import SearchableSelect from '../SearchableSelect/SearchableSelect';
import MapPinIcon from '../../icons/IconLib/MapPinIcon';
import { IWarehouseLocation } from '../../../modules/API/Warehouse/models/locations';

interface Props {
    locations: IWarehouseLocation[];
    value: IWarehouseLocation | null;
    onSelect: (location: IWarehouseLocation | null) => void;
    placeholder?: string;
    disabled?: boolean;
    readOnly?: boolean;
    allowClear?: boolean;
    clearLabel?: string;
    className?: string;
}

const WarehouseLocationSelector: React.FC<Props> = ({
    locations,
    value,
    onSelect,
    placeholder,
    disabled,
    readOnly,
    allowClear,
    clearLabel,
    className,
}) => {
    const [t] = useTranslation('selectors');

    return (
    <SearchableSelect<IWarehouseLocation>
        items={locations}
        value={value}
        onSelect={onSelect}
        getKey={(l) => l.RecID}
        getLabel={(l) => l.CodeLocation.trim()}
        getSearchText={(l) => `${l.CodeLocation} ${l.Line ?? ''}`}
        placeholder={placeholder}
        disabled={disabled}
        readOnly={readOnly}
        allowClear={allowClear}
        clearLabel={clearLabel ?? t('selectors_clear')}
        leadingIcon={<MapPinIcon />}
        emptyLabel={t('selectors_location_empty')}
        className={className}
    />
    );
};

export default WarehouseLocationSelector;
